module.exports = __webpack_public_path__ + "img/zh_sgyl.17ec672e.svg";